import addDays from "date-fns/addDays";
import moment from "moment";
import { getAuthData } from "../../services/AuthService";


export interface iQuotationFilter {
    QuotationNo: string;
    CustomerID: number;
    EndUserID: number;
    From: string;
    To: string;
    StaffID: number;
    Region: string;
    readonly Reader: string;
}

export class QuotationFilter {
    QuotationNo: string;
    CustomerID: number;
    EndUserID: number;
    From: string;
    To: string;
    StaffID: number;
    Region: string;
    readonly Reader: string;

    constructor();
    constructor(obj: iQuotationFilter);	
    constructor(obj?: iQuotationFilter) { 
        this.QuotationNo = obj?.QuotationNo ?? "";
        this.CustomerID = obj?.CustomerID ?? 0;
        this.EndUserID = obj?.EndUserID ?? 0;
        this.From = moment(obj?.From ?? addDays(new Date(), -7)).format();
        this.To = moment(obj?.To ?? new Date()).format();
        this.StaffID = obj?.StaffID ?? 0;
        this.Region = obj?.Region ?? "ALL";
        this.Reader = getAuthData()?.userName ?? "";    
    }
}

export interface iQuotationHistoryFilter {
    SearchString: string;
    CustomerID: number;
    EndUserID: number;
    readonly Reader: string;
}

export class QuotationHistoryFilter {
    SearchString: string;
    CustomerID: number;
    EndUserID: number;
    readonly Reader: string;

    constructor();
    constructor(obj: iQuotationHistoryFilter);	
    constructor(obj?: iQuotationHistoryFilter) { 
        this.SearchString = obj?.SearchString ?? "";
        this.CustomerID = obj?.CustomerID ?? 0;
        this.EndUserID = obj?.EndUserID ?? 0;
        this.Reader = getAuthData()?.userName ?? "";    
    }
}